import React from 'react'
import cn from 'classnames'
import { useTranslation } from '@mc/i18n'
import { PlansTier, usePlansContext } from '@mc/plans-ui'
import { BOGO_I18N_NAMESPACE } from '../../../i18n'

interface BogoPricingPlanCellProps {
  tier: PlansTier
  strikedValue?: boolean
}

export const BogoPricingPlanCell = ({
  tier,
  strikedValue = false,
}: BogoPricingPlanCellProps) => {
  const { t } = useTranslation(BOGO_I18N_NAMESPACE)
  const { selectedPlan } = usePlansContext()
  const isTierSelected = selectedPlan?.productId === tier.productId

  const bogoPrice = strikedValue
    ? t('plans.rows.gift.price', {
        currencySymbol: tier.currencySymbol,
      })
    : tier.displayMonthlyPrice

  return (
    <span>
      {strikedValue && (
        <span
          aria-label={t('plans.a11y.oldPrice', {
            price: tier.displayMonthlyPrice,
          })}
          className='mc-mx-1 mc-text--strike'
        >
          {tier.displayMonthlyPrice}
        </span>
      )}
      <span
        aria-label={t('plans.a11y.price', {
          price: bogoPrice,
        })}
        className={cn({
          'mc-text-color-success': isTierSelected && !!strikedValue,
        })}
      >
        {bogoPrice}
      </span>
    </span>
  )
}
